import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSecclLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "seccl-logo",
	"data-name": "Group 1176",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	width: 117,
	height: 58.769,
	viewBox: "0 0 117 58.769",
	fill: "currentColor",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip-path",
		children: /* @__PURE__ */ _jsx("rect", {
			id: "Rectangle_182",
			"data-name": "Rectangle 182",
			width: 117,
			height: 58.769
		})
	}) }), /* @__PURE__ */ _jsxs("g", {
		id: "Group_1175",
		"data-name": "Group 1175",
		clipPath: "url(#clip-path)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Path_1558",
				"data-name": "Path 1558",
				d: "M141.289,118.835a4.566,4.566,0,1,0,4.734,4.5,4.531,4.531,0,0,0-4.734-4.5m0,7.4a2.707,2.707,0,0,1-2.686-2.84,2.69,2.69,0,1,1,5.372,0,2.713,2.713,0,0,1-2.686,2.84",
				transform: "translate(-83.394 -72.572)"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_1559",
				"data-name": "Path 1559",
				d: "M200.238,118.835a4.566,4.566,0,1,0,4.734,4.5,4.531,4.531,0,0,0-4.734-4.5m0,7.4a2.707,2.707,0,0,1-2.686-2.84,2.69,2.69,0,1,1,5.372,0,2.713,2.713,0,0,1-2.686,2.84",
				transform: "translate(-119.393 -72.572)"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_1560",
				"data-name": "Path 1560",
				d: "M261.5,122.613l-2.576-.36s-1.059-.151-.981-.978c0,0-.042-1.134,2.361-.981a4.667,4.667,0,0,1,2.784.874c.258-.085,1.8-1.568-1.33-2.22a9.023,9.023,0,0,0-3.433.006A2.671,2.671,0,0,0,256,121.407s-.375,2.515,3.439,2.757c0,0,.509.051,1.1.127.947.121,1.495.287,1.587,1.023,0,0,.313,1.461-3.245.969a4.224,4.224,0,0,1-3.827-4.016v-3.032s-1.782-.679-1.948.586c0,.9,0,4.125,0,4.125a2.25,2.25,0,0,1-4.5,0v-4.714s-1.783-.678-1.948.587v4.294c0,2.452,1.719,3.819,4.157,3.819a3.966,3.966,0,0,0,3.892-2.046s1.655,2.284,6.054,2.029c0,0,3.216-.021,3.416-2.719,0,0,.371-2.158-2.671-2.583",
				transform: "translate(-150.627 -72.546)"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_1561",
				"data-name": "Path 1561",
				d: "M172.34,113.984h-1.964v2.031l-3.8,0a4.5,4.5,0,1,0,.607,8.98,8.581,8.581,0,0,0,1.408-.134V123.12a9.208,9.208,0,0,1-1.365.121,2.737,2.737,0,0,1-2.837-2.753,2.77,2.77,0,0,1,2.837-2.754h3.144l.007,4.3s-.227,3.646,4.382,2.88V123.18c-2.555.551-2.418-1.058-2.418-1.058v-4.387h2.418v-1.721H172.34Z",
				transform: "translate(-99.136 -69.61)"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_1562",
				"data-name": "Path 1562",
				d: "M225.96,118.831a4.443,4.443,0,0,0-4.644,4.562v7.763s1.781.679,1.947-.586c0-.9.008-3.955.008-3.955a3.521,3.521,0,0,0,2.651,1.315,4.346,4.346,0,0,0,4.683-4.6,4.428,4.428,0,0,0-4.645-4.5m-.05,7.412a2.694,2.694,0,0,1-2.658-2.84,2.664,2.664,0,1,1,5.316,0,2.7,2.7,0,0,1-2.658,2.84",
				transform: "translate(-135.157 -72.569)"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_1563",
				"data-name": "Path 1563",
				d: "M9.833,118.489a4.184,4.184,0,0,0-2.675.9v-.318c0-.3-.117-.418-.418-.418H6.524c-.3,0-.419.117-.419.418v11.168c0,.3.117.418.419.418h.3c.3,0,.418-.117.418-.418v-2.675a5.37,5.37,0,0,0,1.99.351c2.624,0,4.011-1.705,4.011-4.932,0-2.959-1.154-4.5-3.41-4.5M9.082,126.9a4.082,4.082,0,0,1-1.84-.4v-6.136a3.79,3.79,0,0,1,2.391-.853c1.656,0,2.442,1.12,2.442,3.478,0,2.658-.971,3.912-2.992,3.912",
				transform: "translate(-3.728 -72.361)"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_1564",
				"data-name": "Path 1564",
				d: "M32.2,118.489a7.741,7.741,0,0,0-2.624.485.339.339,0,0,0-.167.485l.1.284c.084.234.267.267.685.117a5.885,5.885,0,0,1,1.889-.351c1.689,0,2.457.819,2.457,2.659v.418c-4.128.017-5.8.819-5.8,2.809,0,1.6,1.088,2.525,2.994,2.525a4.7,4.7,0,0,0,2.891-.92v.335a.365.365,0,0,0,.418.418h.218c.3,0,.418-.134.418-.418v-5.35c0-2.307-1.171-3.494-3.478-3.494m2.34,7.557a4.4,4.4,0,0,1-2.657.869c-1.288,0-1.973-.518-1.973-1.5,0-1.354,1.237-1.872,4.63-1.906Z",
				transform: "translate(-17.553 -72.361)"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_1565",
				"data-name": "Path 1565",
				d: "M55.5,118.7a5.8,5.8,0,0,0-2.994.986h-.016v-.485c0-.3-.116-.418-.418-.418h-.234c-.3,0-.418.117-.418.418v8.259c0,.3.117.418.418.418h.3c.3,0,.419-.117.419-.418v-6.838a6.036,6.036,0,0,1,2.826-.769H55.6c.251,0,.368-.134.368-.418v-.318c0-.318-.117-.418-.467-.418",
				transform: "translate(-31.404 -72.492)"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_1566",
				"data-name": "Path 1566",
				d: "M71.511,115.011H68.988v-2.09c0-.3-.134-.4-.319-.4a1.315,1.315,0,0,0-.234.033l-.233.05c-.284.067-.352.234-.352.5v1.906H66.663c-.3,0-.418.117-.418.418v.151c0,.3.117.418.418.418H67.85v5.082c0,2.441,1,3.126,2.642,3.126a3.791,3.791,0,0,0,1.02-.117c.385-.117.418-.234.418-.435v-.334c0-.251-.084-.334-.251-.334a7.816,7.816,0,0,1-1.121.167c-1.3,0-1.57-.786-1.57-2.223V116h2.523c.3,0,.418-.117.418-.418v-.151c0-.3-.117-.418-.418-.418",
				transform: "translate(-40.456 -68.715)"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_1567",
				"data-name": "Path 1567",
				d: "M95.425,118.489c-2.576,0-3.8,1.521-3.8,4.714s1.22,4.715,3.8,4.715,3.794-1.521,3.794-4.715-1.22-4.714-3.794-4.714m0,8.409c-1.84,0-2.626-1.1-2.626-3.695s.786-3.695,2.626-3.695,2.624,1.1,2.624,3.695-.786,3.695-2.624,3.695",
				transform: "translate(-55.958 -72.361)"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_1568",
				"data-name": "Path 1568",
				d: "M119.869,110.458c-2.275,0-3.311,1-3.311,3.11v.184h-.969c-.3,0-.418.117-.418.418v.151c0,.3.116.418.418.418h.969v7.691c0,.3.117.418.418.418h.3c.3,0,.418-.117.418-.418v-7.691H119.7c.3,0,.418-.117.418-.418v-.151c0-.3-.117-.418-.418-.418H117.7v-.117c0-1.605.535-2.156,2.173-2.156.3,0,.418-.117.418-.418v-.184c0-.3-.117-.418-.418-.418",
				transform: "translate(-70.334 -67.456)"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_1569",
				"data-name": "Path 1569",
				d: "M5.363,32.631A14.442,14.442,0,0,0,11.4,33.8a13.826,13.826,0,0,0,6.017-1.217,9.413,9.413,0,0,0,3.967-3.425,9.21,9.21,0,0,0,1.42-5.093,9.7,9.7,0,0,0-2.254-6.6,11.992,11.992,0,0,0-6.625-3.583l-3.29-.766A4.509,4.509,0,0,1,8.09,11.74a3.443,3.443,0,0,1-.879-2.321A3.334,3.334,0,0,1,8.247,6.76a4.4,4.4,0,0,1,2.975-.9,4.915,4.915,0,0,1,3.178.9A3.475,3.475,0,0,1,15.53,9.445l6.734-.35A8.089,8.089,0,0,0,19.313,2.5a11.975,11.975,0,0,0-8-2.5A11.548,11.548,0,0,0,3.38,2.591,8.779,8.779,0,0,0,.45,9.509a9.667,9.667,0,0,0,2.321,6.558A11.953,11.953,0,0,0,9.285,19.74l3.336.767a4.533,4.533,0,0,1,2.523,1.4,3.653,3.653,0,0,1,.9,2.479A3.152,3.152,0,0,1,14.851,27a5.205,5.205,0,0,1-3.313.946,5.669,5.669,0,0,1-3.493-.969c-.856-.646-1.284-1.188-1.284-3L0,24.338a8.872,8.872,0,0,0,1.4,5,9.158,9.158,0,0,0,3.966,3.29",
				transform: "translate(0 0.001)"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_1570",
				"data-name": "Path 1570",
				d: "M139.276,32.563a8.334,8.334,0,0,0,3.674-4.148,11.055,11.055,0,0,0,.951-5.152l-6.23.406a4.471,4.471,0,0,1-1.056,3.215,5.162,5.162,0,0,1-6.265,0,3.955,3.955,0,0,1-1.1-3V9.915a3.942,3.942,0,0,1,1.1-3.02,5.25,5.25,0,0,1,6.265,0,3.945,3.945,0,0,1,1.1,3.02v.72l6.761-.373V9.915a9.692,9.692,0,0,0-1.375-5.228,9.387,9.387,0,0,0-3.831-3.448,14.1,14.1,0,0,0-11.561,0,9.348,9.348,0,0,0-3.854,3.448,9.692,9.692,0,0,0-1.375,5.228V23.887a9.722,9.722,0,0,0,1.375,5.206,9.29,9.29,0,0,0,3.854,3.471,14.1,14.1,0,0,0,11.561,0",
				transform: "translate(-74.802 0.001)"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_1571",
				"data-name": "Path 1571",
				d: "M81.439,28.622H70.494V20.8H79.78a2.795,2.795,0,1,0,0-5.589H70.494l-.1-6.865H81.5a2.854,2.854,0,0,0,2.668-2.934,2.85,2.85,0,0,0-2.679-2.94H63.771l.1,32.013H81.236a2.924,2.924,0,0,0,2.937-2.922,2.878,2.878,0,0,0-2.734-2.94",
				transform: "translate(-38.945 -1.509)"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_1572",
				"data-name": "Path 1572",
				d: "M268.868,30.693a3.042,3.042,0,0,0-3.044-3.042H255.44V1.248l-6.76.366V33.737l17.21,0a3.019,3.019,0,0,0,2.977-3.04",
				transform: "translate(-151.868 -0.762)"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_1573",
				"data-name": "Path 1573",
				d: "M189.653,32.564a14.1,14.1,0,0,0,11.561,0,9.33,9.33,0,0,0,3.831-3.471,9.874,9.874,0,0,0,1.375-5.206A14.428,14.428,0,0,0,206.335,22l-6.677.432v1.457a3.956,3.956,0,0,1-1.1,3,5.161,5.161,0,0,1-6.265,0,3.954,3.954,0,0,1-1.1-3V9.916a3.943,3.943,0,0,1,1.1-3.02,5.251,5.251,0,0,1,6.265,0,3.683,3.683,0,0,1,1.082,2.478c.021.007,6.785-.479,6.752-.352a9.331,9.331,0,0,0-1.343-4.334,9.393,9.393,0,0,0-3.831-3.448,14.1,14.1,0,0,0-11.561,0A9.352,9.352,0,0,0,185.8,4.688a9.692,9.692,0,0,0-1.375,5.228V23.888a9.722,9.722,0,0,0,1.375,5.206,9.29,9.29,0,0,0,3.854,3.471",
				transform: "translate(-112.627)"
			})
		]
	})]
});
export default SvgSecclLogo;
